export const trackCallConversion = () => {
  // Google Ads conversion (existing)
  if (window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: 'AW-17873693389/WtsqCM26tIccEM3V68pC',
      value: 1.0,
      currency: 'USD',
    });
  }

  // GTM dataLayer push for GA4 phone_click event (NEW)
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'phone_click',
    page_path: window.location.pathname,
  });
};
